import React, { useState, useEffect } from "react";
import {Form,Input,Button,Typography,Row,Col,Spin,message,Card} from "antd";
import { useHistory } from "react-router-dom";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import { routes } from "../../../routes/Routes";
import { RightOutlined, UserOutlined, EditOutlined } from '@ant-design/icons';
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import moment from "moment";
import _commonService from "../../../modules/commonService";
import _consumerService from "../../../modules/consumerService";

const { Title, Text } = Typography;

const ConsumerProfile = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [consumerInfo, setConsumerInfo] = useState({});
    const consumerId = localStorage.getItem("ConsumerUserId");
    const consumerFirstName = localStorage.getItem("consumerFirstName");

    useEffect(() => {
        GetConsumerInformationByConsumerId();
    }, []);

    const GetConsumerInformationByConsumerId = async () => {
        try {
            setLoading(true);
            const res = await _consumerService.getConsumerInformationByConsumerId(consumerId);
            if (res?.data) {
                setLoading(false);
                setConsumerInfo(res.data);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching banker information:", error);
        }
    };

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: consumerInfo.Email,
                OldPassword: values.currentPassword,
                NewPassword: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            const res = await _consumerService.changeConsumerLoginPassword(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                form.resetFields();
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        } finally {
            setLoading(false);

        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };
    const onPersonalEditClick = () => {
        history.push({
            pathname: routes.consumerPersonalDetails.path,
            state: { consumerId: localStorage.getItem("ConsumerUserId"), isFromDashboard: true, },
        });
    }

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                {consumerFirstName != "null" &&
                    <Title level={4}>Hello, {consumerFirstName}!</Title>
                }
                <Row gutter={[16, 16]}>
                    <Col xs={24} lg={24}>
                        <Card style={{ borderRadius: 12, width: "100%", height: "100%" }}
                            title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><UserOutlined /> </span>
                                        Personal Details
                                    </Text>
                                    <EditOutlined onClick={onPersonalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >
                            <Row gutter={[12, 12]}>
                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">First Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.App_Det_FirstName || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Middle Initial:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.App_Det_MiddleInitial || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Last Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.App_Det_LastName || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Application Type:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.App_Det_Application_Type || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Date Of Birth:</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {consumerInfo?.App_Det_DateOfBirth
                                            ? moment(consumerInfo.App_Det_DateOfBirth).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Contact Number:</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {consumerInfo?.App_Det_ContactNumber ?
                                            _commonService.formatUSPhoneNumber(consumerInfo.App_Det_ContactNumber) : "N/A"}
                                    </Text>

                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Email:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Email || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">City:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Ident_City || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">State:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Ident_State || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Zip Code:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Ident_ZipCode || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Employer Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Prof_Employer_Name || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Position/Title:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Prof_JobRole || "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={8}>
                                    <Text type="secondary">Number of Years with Employer:</Text>
                                    <br />
                                    <Text className="b-bottm">{consumerInfo.Prof_NO_Years || "N/A"}</Text>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                <Row justify="center" style={{ marginTop: 25 }}>
                    <Col xs={24} md={12} style={{ display: "flex" }}>
                        <Card style={{ borderRadius: 12, width: "100%", height: "100%" }} className="consumerUserProfile">
                            <Title level={5} style={{ fontSize: "20px", marginBottom: 16 }}>Change Password</Title>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                requiredMark={true}
                            >
                                <Form.Item
                                    label="Current Password"
                                    name="currentPassword"
                                    rules={[{ required: true, message: "Current Password is required" }]}
                                >
                                    <Input.Password maxLength={20} placeholder="Enter Current Password" />
                                </Form.Item>

                                <Form.Item
                                    label="New Password"
                                    name="newPassword"
                                    rules={[
                                        { required: true, message: "New Password is required" },
                                        { validator: validatePassword }
                                    ]}
                                >
                                    <Input.Password maxLength={20} placeholder="Enter New Password" />
                                </Form.Item>

                                <Form.Item
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    dependencies={["newPassword"]}
                                    rules={[
                                        { required: true, message: "Confirm Password is required" },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue("newPassword") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error("Passwords do not match"));
                                            }
                                        })
                                    ]}
                                >
                                    <Input.Password maxLength={20} placeholder="Enter Confirm Password" />
                                </Form.Item>

                                <Form.Item style={{ marginTop: 32, textAlign: "center" }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        shape="round"
                                    >
                                        Submit <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </SidebarLayoutConsumer>
        </Spin>
    );
};

export default ConsumerProfile;